export function isNotNull<T>(
  input: T | null | undefined
): input is NonNullable<T> {
  return input != null;
}
